import React from "react";
import headerTextLogo from "../../../../../assets/img/landing-page/headerTextLogo.png";
import { styles } from "./TrainTheFunMobile.styles";

export const TrainTheFunMobile: React.FC = () => {
  return (
    <div className="train_the_fun_mobile" style={styles.trainTheFunMobile}>
      <span
        style={styles.headerSpan}
        className="hidden xs-block fs-h-1 lh-h-1 fw-500 sm-fs-h-2  sm-lh-h-2 xs-fs-h-6 xs-lh-h-6 xs-text-center xs-align-center xs-justify-center c-text-1 "
      >
        <div style={styles.logoContainer}>
          <img src={headerTextLogo} style={styles.headerTextLogo} />
        </div>
        <br className="xs-hidden" />
        <span
          style={styles.trainFunText}
          className="lh-h-1 sm-lh-h-2  xs-lh-h-6 "
        >
          Train the fun way!
        </span>
      </span>
    </div>
  );
};
